import * as React from 'react';
import OkCancelModal from '../../form-components/OkCancelModal.component';
import SelectList from '../../form-components/SelectList.component';
import Typography from '@mui/material/Typography';
import {TextField} from '@mui/material';
import {uuid} from '../../../utils/utils';
import {PsfCategory} from '../../../@types/psfTemplate';

export default function AddCategoryModal(props: {
    open: boolean;
    title: string;
    categories: PsfCategory[]|undefined;
    onClose: () => void;
    onConfirm: (parent: PsfCategory|null, category: string) => void;
}): React.ReactElement {
   
    const { open, title, categories, onConfirm, onClose } = props;
    const [parentCategory, setParentCategory] = React.useState<number>(0);
    const [dataItems, setDataItems] = React.useState<any[]>([]);
    const [category, setCategory] = React.useState<string>('');
    const uuidRef = React.useRef(uuid());
    const [error, setError] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>('');

    React.useEffect(() => {
        let items: any[] = [];
        if (categories && categories.length > 0) {
            categories.forEach((cat, index) => {
                items.push({ id: index + 1, name: cat.path.replaceAll('::', ' > ')});
            })
        }
        setDataItems(items);
    }, [categories]);

    const onParentCategoryChange = (event: React.ChangeEvent<{ value: unknown }>): void => {
        setParentCategory(event.target.value as number);
    };

    const handleCategoryChange = (event: React.ChangeEvent<HTMLTextAreaElement|HTMLInputElement>): void => {
        setCategory(event.target.value);
        validateCategory(event.target.value);
    };

    const validateCategory = (catName: string): void => {
        if (catName === undefined || catName === '') {
            setError(true)
            setErrorMessage('Category name is required.');
        } else if (parentCategory < 1 ?
            categories?.find((cat: PsfCategory) => cat.path.split('::')[0] == catName) !== undefined
            :
            categories?.find((cat: PsfCategory) => cat.path == categories?.at(parentCategory-1)?.path.concat('::').concat(catName)) !== undefined
        ) {
            setError(true);
            setErrorMessage('Category name already exists.');
        } else {
            setError(false);
            setErrorMessage('');
        }
    }

    return (
        <OkCancelModal
            open={open}
            title={title}
            okButtonText='Add'
            onClose={onClose}
            onConfirm={(): void => {
                onConfirm(parentCategory < 1 || categories === undefined ? null : categories[parentCategory-1], category);
                setCategory('');
            }}
            okToConfirm={(): boolean =>  !error && category !== ''}
        >
            {dataItems?.length > 0 &&
                <Typography variant='body1'>
                    Select a parent category
                </Typography> &&
                <SelectList
                    value={parentCategory}
                    label='Parent Category'
                    items={dataItems}
                    showTopLevel={true}
                    topLevelLabel='--Top Level--'
                    onChange={onParentCategoryChange} />
            }
            {dataItems?.length > 0 && <hr />}
            <TextField
                label='Category'
                aria-label='category'
                type='text'
                variant="outlined"
                size='small'
                id={`category-input-${uuidRef.current}`}
                autoComplete='on'
                value={category|| ''}
                onChange={handleCategoryChange}
                sx={{
                    '& input': {
                        border: 'none',
                    }
                }}
                error={error}
                helperText={errorMessage}
                fullWidth
            />
        </OkCancelModal>
    );
}
